import { jsx as _jsx } from "react/jsx-runtime";
export default function CheckmarkIcon(props) {
    return /*#__PURE__*/ _jsx("svg", {
        width: "13",
        height: "10",
        viewBox: "0 0 13 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1.5 3.91667L5.48565 8L12.3182 1",
            stroke: "white",
            "stroke-width": "1.5"
        })
    });
}
